/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="79.64"
        height="95.58"
        viewBox="0 0 79.64 95.58"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#0e497b"
          d="M38.99.32C28.76 9.5 16.56 14.07 1.21 14.5A1.25 1.25 0 0 0 0 15.75v15.24a138 138 0 0 0 .84 16.36l.17 1.33A63.44 63.44 0 0 0 6.32 67.5c6 12.67 16.55 22 33.08 28a1.21 1.21 0 0 0 .84 0c16.53-5.94 27.14-15.32 33.08-28 3.85-8.22 5.64-17.19 6.16-28.67l.06-1.51c0-.76 0-1.54.06-2.32V15.79a1.25 1.25 0 0 0-1.17-1.29c-15.35-.43-27.55-5-37.78-14.18a1.23 1.23 0 0 0-1.66 0Zm.83 2.59.17.15c10.14 8.7 22.14 13.21 36.88 13.91h.27V34.98c-.27 13-1.95 22.72-6 31.46l-.24.51c-5.62 11.63-15.44 20.3-30.73 25.94l-.26.09.42.16c-16-5.7-26.09-14.64-31.74-26.64l-.25-.53c-3.2-7-4.86-14.69-5.51-24.21l-.09-1.44c-.1-1.7-.16-3.46-.2-5.28V17.03h.27c14.69-.76 26.69-5.27 36.84-13.97Z"
          className="icon-fill icon-base"/>
        <path
          fill="#ffb81c"
          d="M43.89 65.63V51.89h13.67v-8.2H43.89V29.95h-8.14v13.74H22.08v8.2h13.67v13.74h8.14z"
          className="icon-fill icon-accent"
          fillRule="evenodd"/>
        <path
          fill="#ffb81c"
          d="M35.75 66.38a.75.75 0 0 1-.74-.64v-13.1H22.08a.74.74 0 0 1-.74-.65v-8.3a.75.75 0 0 1 .65-.74h13v-13a.75.75 0 0 1 .65-.74h8.24a.75.75 0 0 1 .74.65v13.08h12.94a.75.75 0 0 1 .74.65v8.3a.76.76 0 0 1-.65.75h-13v13a.76.76 0 0 1-.65.75h-8.25Zm7.39-35.68H36.5v13a.75.75 0 0 1-.65.74h-13v6.7h12.9a.75.75 0 0 1 .74.65v13.09h6.64v-13a.75.75 0 0 1 .65-.74h13v-6.7H43.89a.75.75 0 0 1-.74-.65V30.7Z"
          className="icon-fill icon-accent"/>
      </svg>

    );
  }
}

Icon.displayName = 'ShieldWithCrossIcon';

export default Icon;
